








































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import Bridge from '@/common/bridge';
import getUrlParam from '@/common/utils/getUrlParam';
import fetch from '@/common/api/fetch';
import getSMSData from '@/mixins/getSMSData';
import getActivityType from '@/common/utils/getActivityType';
import SelectInstNotice from './SelectInstNotice.vue';
interface Payload {
  instIds?: Array<string>;
}

@Component({
  components: {
    'activity-label': ActivityLabel,
    'select-inst-notice': SelectInstNotice,
  },
})
export default class ActivityStartTime extends Vue {
  @Getter('orgId') orgId!: string;
  @Getter('instIds') instIds!: Array<string>;
  @Getter('instList') instList!: Array<object>;
  @Getter('section') section: any;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('xcxType') xcxType!: string;
  @Getter('supportPay') supportPay: any;
  @Getter('channel') channel: any;
  @Getter('releaseStatus') releaseStatus: any;

  @Action('changeInstIds') changeInstIds!: Function;
  @Action('changeInstList') changeInstList!: Function;
  @Action('changeShowFooter') changeShowFooter!: Function;
  instIdList: Array<string> = ['0'];
  instName: string = '所有校区';
  searchInst: string = '';
  showInstPicker: boolean = false;
  type: string = getUrlParam('type') as string;
  customStyle: any = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  };
  showTip: boolean = false;
  hasPay: boolean = true;
  hasNoPay: boolean = true;
  showAll: boolean = true;
  showNotice: boolean = false;
  activityType: string = getActivityType();
  isCopy: boolean = getUrlParam('state') === 'copy';

  @Watch('showInstPicker')
  changeShowPicker() {
    if (!this.showInstPicker) {
      this.changeShowFooter(true);
      if (this.searchInst) {
        this.searchInst = '';
        this.changeSearch();
      }
    }
  }

  mounted() {
    setTimeout(() => {
      if (this.isCopy && (this.activityType !== 'tyType' && this.channel !== 'XM_CASHIER')) {
        this.showNotice = true;
      }

      this.instIdList = this.instIds;
      if ((this.isCopy && this.supportPay && this.channel !== 'XM_CASHIER') && this.activityType !== 'tyType') {
        this.instIdList = ['0'];
      }
      this.showTip = this.instList.some((item: any) => !item.hasPay);
      let list = this.instIdList;

      if (list.includes('0') && !this.searchInst) {
        list = this.instList.filter((item: any) => item && (item.hasPay || this.activityType == 'tyType')).map((item: any) => item.instId);
        if (list.length) {
          this.instName = '所有校区';
        } else {
          this.instIdList = [];
          this.instName = '无适用校区';
        }
      } else if (!list.includes('0')) {
        this.instName = (this.instList.find((item: any) => item.instId === list[0]) as any).name;
        list.length > 1 && !(this.instName || '').includes('等共') && (this.instName += `等共${list.length}家`);
      }
      getSMSData(list);
      this.changeInstIds(list);
      this.hasPay = this.instList.some((value: any) => value.hasPay);
      this.hasNoPay = this.instList.some((value: any) => !value.hasPay);
    }, 1000);
  }

  get startTimeStyle() {
    return {
      color: this.section.inputFontColor,
      backgroundColor: this.section.inputBackgroundColor,
    };
  }

  changeSearch() {
    const data = { orgId: this.orgId, instName: this.searchInst };
    fetch.pureUrl('sales/anon/inst/getInstIdByOrgIdAndInstName', data).then((res: any) => {
      this.changeInstList(res.result);
      this.showAll = !this.searchInst;
    });
  }

  selectInst(item: any) {
    console.log('selectInst', item);
    if (!item.hasPay&& this.activityType!=='tyType') return;
    if (this.instIdList.includes('0') || item.instId === '0') {
      this.instIdList = [item.instId];
    } else {
      let list: any = [];
      const index = this.instIdList.indexOf(item.instId);
      if (index < 0) {
        this.instIdList.map((value) => list.push(value));
        list.push(item.instId);
      } else {
        this.instIdList.map((value, number) => {
          if (number !== index) {
            list.push(value);
          }
        });
      }
      this.instIdList = list;
    }
  }

  closeTip() {
    this.showTip = false;
  }

  handleShow() {
    if (
      this.type === 'reEdit' ||
      (this.xcxFlag && !this.xmMajordomo) ||
      (this.type === 'edit' && this.supportPay && this.channel !== 'XM_CASHIER' && !this.isCopy)
    )
      return null;
    this.showInstPicker = true;
    this.changeShowFooter(false);
  }

  handleCancle() {
    this.instIdList = this.instIds;
    this.showInstPicker = false;
  }

  handleOk() {
    let list = this.instIdList;
    if (list.length > 0) {
      if (list.includes('0') && !this.searchInst) {
        list = this.instList.filter((item: any) => item && (item.hasPay || this.activityType == 'tyType')).map((item: any) => item.instId);
        if (list.length) {
          this.instName = '所有校区';
        } else {
          this.instIdList = [];
          this.instName = '无适用校区';
        }
      } else if (!list.includes('0')) {
        this.instName = ((this.instList.find((item: any) => item.instId === list[0]) as any) || {}).name || this.instName;
        list.length > 1 && !(this.instName || '').includes('等共') && (this.instName += `等共${list.length}家`);
      }
      getSMSData(list);
      this.changeInstIds(list);
      this.showInstPicker = false;
    } else {
      Vue.$toast.error('请选择校区');
    }
  }
  closeModal() {
    this.showNotice = false;
  }
}
